import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

class DynamicDateField extends React.Component {
  render() {
    let field = this.props.field;
    let dateType = this.props.dateType; //Day, Month or Year
    return (
      <>
        <Autocomplete
          id={`${field.FieldCode}-${dateType[0]}`}
          value={dateType[2]}
          options={this.props.fieldOptions}
          getOptionLabel={this.props.fieldOptionLabels}
          autoHighlight
          autoSelect
          disabled={field.IsReadonly}
          onChange={this.props.eventHandle}
          renderInput={(params) => (
            <TextField
              className="dynamic-date-input"
              {...params}
              type={dateType[1]}
              name={field.FieldCode}
              label={dateType[0]}
              error={this.props.error}
              required={this.props.isRequired}
              variant="filled"
              margin="none"
              fullWidth
            />
          )}
        />
      </>
    );
  }
}

export default DynamicDateField;
